var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumEthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 150,
    height: 150,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 784.37 1277.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m392.07 0-8.57 29.11v844.63l8.57 8.55 392.06-231.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 0 0 650.54l392.07 231.75V472.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "m392.07 956.52-4.83 5.89v300.89l4.83 14.1 392.3-552.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M392.07 1277.4V956.52L0 724.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m392.07 882.29 392.06-231.75-392.06-178.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m0 650.54 392.07 231.75V472.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEthLogo);
export default __webpack_public_path__ + "static/media/ethereum-eth-logo.9efa551cf6950cb7d60a1db975fbedbe.svg";
export { ForwardRef as ReactComponent };